<template>
  <v-card v-if="data.channel">
    <v-card-title class="pl-2 pr-0 pt-1 pb-1" :class="[color]" style="font-size: 12px; height: 44px;">
      <v-layout row>
        <v-flex align-center d-flex style="font-size: 12px; overflow: hidden;">
          <span>{{data.channel.title}}</span>
        </v-flex>
        <v-flex align-center d-flex style="flex: 0 0 auto;" v-if="!developer">
          <v-btn small flat icon :color="$dark() ? 'white' : 'grey'" class="ml-1 mt-1 mb-1 mr-0" :href="data.url" target="_blank"><v-icon>play_circle_outline</v-icon></v-btn>
          <v-btn small flat icon :color="$dark() ? 'white' : 'grey'" class="mr-1 mt-1 mb-1 ml-0" @click.stop="close"><v-icon>close</v-icon></v-btn>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-card-text class="pa-0 black">
      <preview v-model="player_info" :url="data.url" :load-player="load_player" style="position: relative;">
        <span style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 100%; text-align: center;" v-if="!load_player" class="white--text">No preview</span>
      </preview>
    </v-card-text>
    <v-card-title class="pa-0 pl-2 pr-2" :class="[color]" style="font-size: 12px; text-transform: capitalize;">
      <span v-if="player_info.width && player_info.height">{{player_info.width}} x {{player_info.height}}</span>
      <v-spacer></v-spacer>
      {{data.state}}
    </v-card-title>
  </v-card>
</template>

<script>
import Preview from './Preview'
export default {
  props: ['data', 'developer'],
  data() {
    return {
      player_info: {width: 0, height: 0}
    } 
  },
  components: {
    Preview
  },
  computed: {
    load_player () {
      return this.data.url && this.data.state == "connected";
    },
    color () {
      if (this.data.state == "listening") return `yellow ${this.$dark() ? 'darken' : 'lighten'}-4`;
      if (this.data.state == "disconnected") return `red ${this.$dark() ? 'darken' : 'lighten'}-4`;
      if (this.data.state == "connecting") return `orange ${this.$dark() ? 'darken' : 'lighten'}-4`;
      if (this.data.state == "connected") return `${this.$dark() ? 'light-green darken-3' : 'green lighten-4'}`;
      return undefined;
    },
  },
  methods: {
    close() {
      if (!this.$store.state.account) return;
      var acc = _.cloneDeep(this.$store.state.account);
      acc.meta.monitor_channel_filter = _.xor(acc.meta.monitor_channel_filter, [this.data.key]);
      this.$store.dispatch("update_profile", acc);
    }
  }
}
</script>
